import api from '@/api'

export default {
  // 获取球队职位列表-ALL
  getAllDuty () {
    return api({
      url: '/squad/duty/all',
      methods: 'GET'
    })
  }
}
